import { useEffect } from 'react';
import { clearAuthErrorsAction } from '../modules/auth/actions';
import useCustomToast from '../view/components/UI/toast';
import { useAppDispatch } from './reduxHooks';

export const useAuthErrorHandling = (isError: string | null) => {
  const toast = useCustomToast();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isError) {
      toast(isError, 'error', 2000, () => dispatch(clearAuthErrorsAction()));

      return () => {
        dispatch(clearAuthErrorsAction());
      };
    }
  }, [isError, dispatch, toast]);
};
